import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://liqnocchgozzycjndqcx.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxpcW5vY2NoZ296enljam5kcWN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDYyOTM3OTMsImV4cCI6MjAyMTg2OTc5M30.YnAb8rzo8DgFuIVClRqsCHSY86rJRWeZKnoA46BRbUI'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export default supabase
